
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { IoDownloadOutline } from 'react-icons/io5';

const QuestionPaperManagement = () => {
  const [papers, setPapers] = useState([
    {
      id: 1,
      date: '2024-11-10',
      title: 'Computer Science Engineering - Semester 1',
      pdf: '/path/to/first-paper.pdf',
    },
    {
      id: 2,
      date: '2024-11-12',
      title: 'Modern Office Management - Semester 1',
      pdf: '/path/to/second-paper.pdf',
    },
    {
      id: 3,
      date: '2024-11-15',
      title: 'Computer Science Engineering - Semester 2',
      pdf: '/path/to/third-paper.pdf',
    },
  ]);

  const handleAddPaper = () => {
    const newPaper = {
      id: papers.length + 1,
      date: '2024-11-18',
      title: 'Advanced Programming - Semester 3',
      pdf: '/path/to/fourth-paper.pdf',
    };
    setPapers([...papers, newPaper]);
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center p-14 ">
      <div className="max-w-7xl w-full bg-white border-4 border-teal-500 rounded-lg p-6 sm:p-8">
        <h2 className="text-2xl font-bold text-teal-500 mb-6">Question Paper Management</h2>

        {/* Add Question Paper Button */}
        <button
          onClick={handleAddPaper}
          className="mb-6 px-6 py-2 bg-teal-500 text-white rounded-md hover:bg-teal-600"
        >
          Add Question Paper
        </button>

        {/* Table for Question Papers */}
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-300 rounded-lg shadow-md">
            <thead className="bg-teal-500 text-white">
              <tr>
                <th className="px-6 py-3 text-left text-xs sm:text-sm md:text-base">S.No.</th>
                <th className="px-6 py-3 text-left text-xs sm:text-sm md:text-base">Date</th>
                <th className="px-6 py-3 text-left text-xs sm:text-sm md:text-base">Title</th>
                <th className="px-6 py-3 text-left text-xs sm:text-sm md:text-base">Download</th>
              </tr>
            </thead>
            <tbody>
              {papers.map((paper) => (
                <motion.tr
                  key={paper.id}
                  className="border-b"
                  initial={{ width: 0 }}
                  animate={{ width: '100%' }}
                >
                  <td className="px-6 py-4 text-xs sm:text-sm md:text-base">{paper.id}</td>
                  <td className="px-6 py-4 text-xs sm:text-sm md:text-base">{paper.date}</td>
                  <td className="px-6 py-4 text-xs sm:text-sm md:text-base">{paper.title}</td>
                  <td className="px-6 py-4 text-xs sm:text-sm md:text-base">
                    <a
                      href={paper.pdf}
                      download
                      className="flex items-center text-teal-500 hover:underline"
                    >
                      <IoDownloadOutline className="mr-2" /> Download
                    </a>
                  </td>
                </motion.tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default QuestionPaperManagement;
